const API = {

  mapParams: {
    serverPath: process.env.REACT_APP_API_GL_SERVER_PATH,
    accessToken: process.env.REACT_APP_MAP_ACCESS_TOKEN
  },
  map: {
    styles: (name = 'default') => {
      const files = {
        default: 'mapion.default',
        boundary: 'boundary-map',
        street: 'street-map',
        terrain: 'media-hillshade',
        kana: 'media-kana'
      };
      const fileName = files[name] || files.default;
      const p = API.mapParams;
      return `${p.serverPath}/style/${fileName}.json?access_token=${p.accessToken}`;
    },
    tile: (style, z, x, y) => {
      return `${API.mapParams.serverPath}/tile/${style}/${z}/${x}/${y}.png?access_token=${API.mapParams.accessToken}`;
    },
    elev: (lng, lat) => {
      return `${API.mapParams.serverPath}/elev/json?locations=${lng}%2c${lat}&island=org&dtm=wgs&access_token=${API.mapParams.accessToken}`;
    },
    sunmoon: (lng, lat, date) => {
      return `${API.mapParams.serverPath}/sunmoon/json?locations=${lng}%2c${lat}&dtm=jgd&island=org&date=${date}&access_token=${API.mapParams.accessToken}`;
    },
  },

  bffParams: {
    baseUrl: process.env.REACT_APP_API_BFF_BASE_URL,
    searchMaxRadius: 5000,
    suggestMaxRadius: 3000,
    suggestDefaultRadius: 3000,
  },
  bff: {
    baseUrl: process.env.REACT_APP_API_BFF_BASE_URL,
    search: (query, lat, lon, radius = null) => {
      let url = `${API.bffParams.baseUrl}/search?q=${encodeURIComponent(query)}&lat=${lat}&lon=${lon}`;
      if (radius) {
        url += `&radius=${Math.min(radius, API.bffParams.searchMaxRadius)}`;
      }
      return url;
    },
    suggest: (query, lat, lon, radius = null) => {
      let url = `${API.bffParams.baseUrl}/suggest?q=${encodeURIComponent(query)}&lat=${lat}&lon=${lon}`;
      if (radius) {
        url += `&radius=${Math.min(radius, API.bffParams.suggestMaxRadius)}`;
      }
      return url;
    },
    responseCode: {
      success: 20000,
      internalServerError: 50000
    }
  },

  reverseGeocoderParams: {
    baseUrl: process.env.REACT_APP_API_GEOCODER_URL,
    oe: 'utf8',
    dtm: 'wgs',
    island: 'org'
  },
  reverseGeocoder: (lon, lat, callbackName, timestamp) => {
    const p = API.reverseGeocoderParams;
    return `${p.baseUrl}/${lon}/${lat}/ReverseGeocoder.json?oe=${p.oe}&dtm=${p.dtm}&island=${p.island}&cb=${callbackName}&_=${timestamp}`;
  },

  // 近くの駅を検索するAPI
  stationPoiCircleParams: {
    baseUrl: process.env.REACT_APP_API_STATION_POICIRCLE_URL,
    grp: 'mapion_navi',
    vo: 'mbml',
    pm: 3,
    dist: 20000,
    sgrp: 'st01',
    scl: 1,
    json: 1,
    dtm: 'wgs'
  },
  stationPoiCircle: (lon, lat, callbackName) => {
    const p = API.stationPoiCircleParams;
    return `${p.baseUrl}?grp=${p.grp}&vo=${p.vo}&pm=${p.pm}&dist=${p.dist}&sgrp=${p.sgrp}&scl=${p.scl}&json=${p.json}&dtm=${p.dtm}&nl=${lat}&el=${lon}&callback=${callbackName}`;
  },

  // local: 周辺検索  keyword: キーワード検索
  stationLocalParams: {
    baseUrl: process.env.REACT_APP_BASE_URL,
    searchPath: 'search',
    endpoint: 'station2',
    type: 'local',
    dist: 20000,
    wt: 'json',
    key: 'mapion_new_map',
    dtm: 'wgs',
    rows: 5,
  },
  stationLocal: (lon, lat, radius, rows = null) => {
    const p = API.stationLocalParams;
    return `${p.baseUrl}/${p.searchPath}/${p.endpoint}/${p.type}?lat=${lat}&lon=${lon}&radius=${radius}&wt=${p.wt}&rows=${rows || p.rows}&dtm=${p.dtm}&key=${p.key}`;
  },
  stationPoiCodeParams: {
    baseUrl: process.env.REACT_APP_BASE_URL,
    searchPath: 'search',
    endpoint: 'station2',
    wt: 'json',
    key: 'mapion_new_map',
    dtm: 'wgs',
    rows: 1,
  },
  stationPoiCode: (poicode) => {
    const p = API.stationPoiCodeParams;
    return `${p.baseUrl}/${p.searchPath}/${p.endpoint}/select?wt=${p.wt}&key=${p.key}&dtm=${p.dtm}&rows=${p.rows}&q=poi_code:${encodeURIComponent(poicode)}`;
  },

  // サーチAPIアクセスしてpoi検索
  searchPoiCodeParams: {
    baseUrl: process.env.REACT_APP_BASE_URL,
    searchPath: 'search',
    endpoint: 'map_mini',
    wt: 'json',
    key: 'mapion_new_map',
    dtm: 'wgs',
    rows: 1,
  },
  searchPoiCode: (poicode) => {
    const p = API.searchPoiCodeParams;
    return `${p.baseUrl}/${p.searchPath}/${p.endpoint}/select?wt=${p.wt}&key=${p.key}&dtm=${p.dtm}&rows=${p.rows}&q=poi_code:${encodeURIComponent(poicode)}`;
  },

  // 天気API
  weatherParams: {
    baseUrl: process.env.REACT_APP_API_WEATHER_URL,
    mode: 1
  },
  weather: (lon, lat) => {
    const p = API.weatherParams;
    return `${p.baseUrl}?nl=${lat}&el=${lon}&mode=${p.mode}&callback=weatherCallback`;
  },

};

export default API;